import React, { useCallback, useState } from "react";
import { FilterProps } from "@usereactify/search";
import ReactSlider, { ReactSliderProps } from "react-slider";
import { FilterChevron } from "./FilterChevron";

export type FilterSliderProps = React.ComponentProps<NonNullable<FilterProps["renderFilterSlider"]>>;

export const FilterSlider: React.FC<FilterSliderProps> = (props) => {
  const [open, setOpen] = useState(false);
  const toggleFilter = useCallback(() => setOpen(!open), [open]);

  const values = props?.filterSliderProps?.value;

  // use on after change handler to prevent search results updating too quickly
  const reactSliderProps = {
    ...(props?.filterSliderProps?.reactSliderProps || {}),
    onChange: undefined,
    onAfterChange: props?.filterSliderProps?.reactSliderProps?.onChange,
  } as ReactSliderProps;

  return (
    <div className={`rs__filter fade-in ${(open && "open") || ""}`}>
      <div className="rs__filter-heading" onClick={toggleFilter}>
        <span>{props.filter.name}</span>

        <FilterChevron />
      </div>

      <div className={`rs__filter__slider overflow-hidden ${open ? "h-20" : "h-0"}`}>
        <ReactSlider {...reactSliderProps} />
        <div className="flex justify-between mt-4">
          {values?.[0] && <span className="select-none">${values?.[0]}</span>}
          {values?.[1] && <span className="select-none">${values?.[1]}</span>}
        </div>
      </div>
    </div>
  );
};
